import Header from "../../commons/header"
import Footer from "../../commons/footer"
import ProjectMain from "./main";


const Project = () => {
    return (
        <>
            <Header />
            <ProjectMain />
            <Footer />
        </>
    )
};

export default Project;